module.exports = __webpack_public_path__ + "fonts/f82fc2f.otf";